import { auth, provider, db } from '../firebase/firebase'; 
import { signInWithPopup, signOut } from 'firebase/auth'; 
import { doc, getDoc, setDoc } from 'firebase/firestore';
import axios from 'axios'; // Ensure axios is imported
import { v4 as uuidv4 } from 'uuid'; // Import UUID v4
import Cookies from 'js-cookie'; // Import js-cookie

export const handleGoogleLogin = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    // Fetch user data from Firestore
    const userDocRef = doc(db, "users", user.uid);
    const userDoc = await getDoc(userDocRef);
    let userRole = "User"; // Default role
    let tenantId = uuidv4(); // Generate a new UUID for tenantId

    if (!userDoc.exists()) {
      // If user does not exist, create a new user document with default role and tenantId
      await setDoc(userDocRef, {
        email: user.email,
        userRole: userRole,
        tenantId: tenantId, // Store the generated tenantId

      });
      console.log(`New user created with default role: ${userRole} and tenantId: ${tenantId}`);
    } else {
      const userData = userDoc.data();
      // Fetch existing user role or default to "User" if not defined
      userRole = userData.userRole || "User"; 
      
      // If userRole is not Admin or Mentor, assign default User
      if (userRole !== "Admin" && userRole !== "Mentor") {
        userRole = "User";
      }
      tenantId = userData.tenantId || tenantId; // Use existing tenantId if it exists
    }

    // Generate JWT
    const jwtResponse = await generateJWT(user.email, tenantId, userRole); // Use tenantId
    const { token } = jwtResponse; // Extract the token from the response

    // Storing user data in cookies
    Cookies.set("email", user.email, { expires: 7 }); // Set cookie to expire in 7 days
    Cookies.set("photoURL", user.photoURL, { expires: 7 });
    Cookies.set("userName", user.displayName, { expires: 7 });
    Cookies.set("authToken", user.uid, { expires: 7 });
    Cookies.set("jwtToken", token, { expires: 7 }); // Store the JWT token in cookies
    console.log("jwtToken: ", token);
    Cookies.set("userRole", userRole, { expires: 7 }); // Store the user role
    Cookies.set("tenantId", tenantId, { expires: 7 }); // Store the tenantId

    console.log('User logged in successfully');
  } catch (error) {
    console.error("Error signing in with Google:", error);
  }
};

export const handleSignOut = async () => {
  try {
    await signOut(auth);
    
    // Clear user data from cookies
    Cookies.remove("email");
    Cookies.remove("photoURL");
    Cookies.remove("userName");
    Cookies.remove("authToken");
    Cookies.remove("jwtToken");
    Cookies.remove("userRole");
    Cookies.remove("tenantId");

    console.log('User signed out successfully');
  } catch (error) {
    console.error("Error signing out:", error);
  }
};

/**
 * Check if User is Logged In
 * @returns {boolean} - Returns true if a user is logged in, false otherwise.
 */
export const isUserLoggedIn = () => {
  return !!Cookies.get("jwtToken"); // Check for JWT token in cookies
};

/**
 * Get Current User
 * @returns {object|null} - Returns user object if logged in, null otherwise.
 */
export const getCurrentUser = () => {
  if (isUserLoggedIn()) {
    return {
      email: Cookies.get("email"),
      photoURL: Cookies.get("photoURL"),
      userName: Cookies.get("userName"),
      uid: Cookies.get("authToken"),
      userRole: Cookies.get("userRole")
    };
  }
  return null;
};

export const generateJWT = async (email, tenantId, userRole) => {
  try {
    const applicationId = "9gPUp0om0daj"; // Define the applicationId
    const response = await axios.post('https://api-pilsilhmsa-uc.a.run.app/auth/login', {
      email,
      tenantId,
      userRole,
      applicationId // Include applicationId in the request body
    });

    return response.data; // Return the response data containing the token
  } catch (error) {
    console.error("Error generating JWT:", error.response ? error.response.data : error.message);
    throw error; // Rethrow the error for further handling if needed
  }
};

// Check for JWT token in cookies on app load
export const checkForToken = () => {
  const token = Cookies.get("jwtToken");
  if (!token) {
    // Logic to request a new token if it doesn't exist
    console.log("Token not found, requesting a new one...");
    // You can call handleGoogleLogin or any other function to re-authenticate
  }
};
